import * as motorhomeConstants from '@/constants/products/motorhome';
import * as commonConstants from '@/constants/common';

import { DATE_FORMAT } from '@/helpers/date';

const constants = Object.assign(
  {},
  commonConstants,
  motorhomeConstants,
);

export const getClaimsRules = claim => ({
  dateOfClaim: {
    date_format: DATE_FORMAT,
    before: {
      compare: 'today',
      equal: true,
    },
    after: {
      compare: '-5 years',
    },
  },
  costOfRepairs: {
    is_not: { other: null },
    integer: true,
    between: [0, 9999999],
  },
  causeOfDescription: {
    is_not: { other: null },
    in: {
      items: constants.DRIVER_CLAIM_CAUSE_OF_DESCRIPTION,
    },
  },
});

export const getConvictionsRules = conviction => ({
  dateOfConviction: {
    date_format: DATE_FORMAT,
    before: {
      compare: 'today',
      equal: true,
    },
    after: {
      compare: '-5 years',
    },
  },
  convictionDeclaredAccident: {
    required: { allowFalse: true },
    typeof: 'boolean',
  },
  offenceCode: {
    is_not: { other: null },
    typeof: 'string',
  },
  alcoholLevel: {
    integer: true,
    between: [0, 999],
    switchedBy: {
      condition: constants.DRIVER_CONVICTION_ALCOHOL_LEVEL_REQUIRED_CODES.includes(conviction.offenceCode),
    },
  },
  alcoholMethodTest: {
    in: {
      items: constants.DRIVER_CONVICTION_ALCOHOL_METHOD_TEST,
      required: constants.DRIVER_CONVICTION_ALCOHOL_LEVEL_REQUIRED_CODES.includes(conviction.offenceCode),
    },
    switchedBy: {
      condition: constants.DRIVER_CONVICTION_ALCOHOL_LEVEL_REQUIRED_CODES.includes(conviction.offenceCode),
    },
  },
  howMuchYouFined: {
    is_not: { other: null },
    integer: true,
    between: [0, 99999],
  },
  pointsReceived: {
    is_not: { other: null },
    integer: true,
    in: {
      items: constants.DRIVER_CONVICTION_POINTS_RECEIVED,
    },
  },
  receivedBanPeriod: {
    is_not: { other: null },
    integer: true,
    between: [0, 99],
  },
});
